import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { API } from "@/context/AuthContext";
import { Search, X } from "lucide-react";

/**
 * Autocompletado de Centros (CeBe SAP). onSelect recibe {codigo, descripcion}.
 */
export default function CentroAutocomplete({ value, onSelect, placeholder = "Buscar centro (CeBe SAP)...", testId = "centro-autocomplete" }) {
  const [q, setQ] = useState(value || "");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => { setQ(value || ""); }, [value]);

  useEffect(() => {
    if (!q || q.length < 2) { setResults([]); return; }
    const t = setTimeout(() => {
      axios.get(`${API}/centros/search`, { params: { q, limit: 10 } })
        .then(r => setResults(r.data.items || []))
        .catch(() => {});
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  useEffect(() => {
    const onClickOutside = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  return (
    <div className="relative" ref={boxRef}>
      <div className="relative">
        <Search size={13} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
        <input value={q} data-testid={testId}
          onChange={e => { setQ(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          placeholder={placeholder}
          className="w-full pl-8 pr-7 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#007934]" />
        {q && (
          <button type="button" onClick={() => { setQ(""); onSelect?.(null); }}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-300 hover:text-gray-500">
            <X size={13} />
          </button>
        )}
      </div>
      {open && results.length > 0 && (
        <div className="absolute z-20 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-56 overflow-auto" data-testid={`${testId}-dropdown`}>
          {results.map(r => (
            <button key={r.codigo} type="button" data-testid={`${testId}-option-${r.codigo}`}
              onClick={() => { setQ(`${r.codigo} — ${r.descripcion}`); setOpen(false); onSelect?.(r); }}
              className="w-full text-left px-3 py-2 text-xs hover:bg-[#f0fdf4] border-b border-gray-50 last:border-0">
              <span className="font-bold text-[#007934]">{r.codigo}</span>
              <span className="text-gray-600 ml-1.5">{r.descripcion}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
